export default __webpack_public_path__ + "9863d6f6500900fcbd01f891b6bd230c.svg";